



























export default {
    props: ['attribute'],
};
